import { Person, RankInstructor, RankScout, instructorRankNames, scoutRankNames } from '../types/form';

export function getInstructorRank(person: Person, rank: RankInstructor | null): string {
  return rank && person.sex in instructorRankNames && rank in instructorRankNames[person.sex] ?
    instructorRankNames[person.sex][rank] : '';
}

export function getScoutRank(person: Person, rank: RankScout | null, fullName: boolean = true): string {
  return rank && person.sex in scoutRankNames && rank in scoutRankNames[person.sex] ?
    scoutRankNames[person.sex][rank][fullName ? 0 : 1] : '';
}
